import React, { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'default';
  size?: 'sm' | 'md';
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', size = 'md' }) => {
  const variants = {
    success: 'bg-emerald-50 dark:bg-emerald-950 text-emerald-700 dark:text-emerald-400 ring-1 ring-emerald-600/20',
    warning: 'bg-amber-50 dark:bg-amber-950 text-amber-700 dark:text-amber-400 ring-1 ring-amber-600/20',
    danger: 'bg-red-50 dark:bg-red-950 text-red-700 dark:text-red-400 ring-1 ring-red-600/20',
    info: 'bg-indigo-50 dark:bg-indigo-950 text-indigo-700 dark:text-indigo-400 ring-1 ring-indigo-600/20',
    default: 'bg-gray-50 dark:bg-gray-800 text-gray-700 dark:text-gray-300 ring-1 ring-gray-600/10',
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
  };

  return (
    <span className={`inline-flex items-center font-medium rounded-lg ${variants[variant]} ${sizes[size]}`}>
      {children}
    </span>
  );
};
